import { useState, useEffect, useMemo } from "react";

import Button from "components/Button/Button";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import {
  // ListItem,
  // Stack,
  Text /*HStack, Badge*/,
  Heading,
  Box,
  VStack,
  CircularProgress,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { Checkbox } from "@chakra-ui/checkbox";
// import QrReader from "react-qr-scanner";
import QrReader from "modern-react-qr-reader";

import { motion, AnimatePresence } from "framer-motion";
// import { useDisclosure } from "@chakra-ui/hooks";
// import { Image } from "@chakra-ui/image";
import { useHistory } from "react-router-dom";

import { ReactComponent as VerifiedIcon } from "assets/svg/verified.svg";
import { ReactComponent as FailedIcon } from "assets/svg/verificationFailed.svg";

// import SubmitPin from "../SubmitPin";

// import capitalize from "lodash/capitalize";
// import toUpper from "lodash/toUpper";

import toPrecision from "util/toPrecision";
// import currencyFormatter from "util/formatter";
// import toCoinLocale from "util/toCoinLocale";
import capitalize from "lodash/capitalize";
import trim from "lodash/trim";
import { useClaimRewardsMutation } from "services/arbitraryApi";

// const Item = ({ name, value }) => {
//   return (
//     <ListItem py="10px" borderBottom="1px solid #EAEAEA">
//       <Stack>
//         <Text fontSize="xs">{name}</Text>
//         <Text mt="0px !important">{value}</Text>
//       </Stack>
//     </ListItem>
//   );
// };

// eslint-disable-next-line
const ForStep1 = ({ state, isOpen, onClose }) => {
  return (
    <>
      <Heading fontSize="24px">Claim Your Reward</Heading>
      <Text color="#6E7191" mt="12px">
        Scan the QR Code on the physical Card to claim your reward
      </Text>
      <Box w="2px" h="100px" />
    </>
  );
};

const ForStep2 = ({ currentStep, gotoNext, setState }) => {
  // const ref = useRef(null);

  const handleScan = (data) => {
    if (data !== null) {
      console.log("Scan Data", data);
      setState({ code: data });
      gotoNext();
    }
  };

  // console.log("QR REF", ref);

  return (
    <>
      <Box borderRadius="8px" overflow="hidden">
        {currentStep === 1 && (
          <Box
            // ref={ref}
            as={QrReader}
            borderRadius="8px"
            // border="1px solid red"
            // maxH="260px"
            facingMode={"user"}
            minW="100%"
            h="100%"
            delay={100}
            onError={(e) => console.log(e)}
            onScan={handleScan}
            style={{ borderRadius: "8px" }}
          />
        )}
      </Box>
    </>
  );
};

const ForStep3 = ({ state, setStep }) => {
  const history = useHistory();

  const [claimReward, { data, isLoading, isError, error, isSuccess }] =
    useClaimRewardsMutation();

  // console.log("CLAIM REWARD :: ", data, error);

  useEffect(() => {
    if (state?.code) {
      console.log("CODE", state?.code);
      claimReward({ qrCode: state.code });
    }
  }, [state, claimReward]);

  const errorMessage = useMemo(() => {
    console.log("ERROR", error?.data?.error);
    const err = String(error?.data?.error).toLowerCase().split("error:");
    console.log(err);
    return capitalize(trim(err[1]));
  }, [error]);

  const successMessage = useMemo(() => {
    const message = `You have successfully claimed your ${toPrecision(
      data?.reward ?? 1,
      data?.unit ?? "cUSD"
    )} reward`;
    return message;
  }, [data]);

  const motionKey = useMemo(
    () =>
      `step3-motion-${!isError ? "loading" : isError ? "error" : "success"}`,
    [isError]
  );

  return (
    <AnimatePresence initial={false} exitBeforeEnter>
      <motion.div
        key={motionKey}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        {isLoading && (
          <VStack>
            <CircularProgress isIndeterminate color="green.400" size="24px" />
          </VStack>
        )}

        {isError && (
          <VStack>
            <Box boxSize="50px" as={FailedIcon} />
            <Text
              textAlign="center"
              fontSize="md"
              color="red.500"
              fontWeight="500"
            >
              {errorMessage}
            </Text>

            <Button
              mt="26px"
              minW="fit-content"
              w="fit-content"
              minH="fit-content"
              h="fit-content"
              size="sm"
              disabled={isLoading}
              onClick={() => setStep(1)}
              // bg="transparent"
              // border="2px solid transparent"
              // color="#03A438"
            >
              Try again
            </Button>
          </VStack>
        )}

        {isSuccess && (
          <VStack>
            <Box boxSize="50px" as={VerifiedIcon} />
            <Text textAlign="center" color="black" fontWeight="600">
              Hooray!! 🥳👏🤝
            </Text>
            <Text
              textAlign="center"
              fontSize="sm"
              color="green.500"
              fontWeight="500"
            >
              {successMessage}
            </Text>

            <Button
              mt="26px"
              minW="fit-content"
              w="fit-content"
              minH="fit-content"
              h="fit-content"
              size="sm"
              onClick={() => {
                history.push(`/dashboard/wallet/${data?.unit ?? "cUSD"}`);
              }}
              // bg="transparent"
              // border="2px solid transparent"
              // color="#03A438"
            >
              View wallet
            </Button>

            <Alert
              status="info"
              // textAlign="center"
              fontWeight="600"
              fontSize="sm"
              mt="44px !important"
              alignItems="flex-start"
              borderRadius="8px"
            >
              <AlertIcon />
              Refer your friends to earn more rewards. Ts & Cs apply
            </Alert>
          </VStack>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

const ClaimReward = ({
  isOpen,
  onClose,
  // state,
  onConfirm,
  isLoading,
  title,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const maxStep = 3;

  const [state, setState] = useState();

  const handleState = (newState) => setState({ ...state, ...newState });

  //   const {
  //     isOpen: isSubmitPinOpen,
  //     onClose: onSubmitPinClose,
  //     onOpen,
  //   } = useDisclosure();

  const previewMap = (step) => {
    const map = {
      0: (
        <ForStep1
          state={state}
          // isOpen={isSubmitPinOpen}
          // onClose={onSubmitPinClose}
        />
      ),
      1: (
        <ForStep2
          state={state}
          // isOpen={isSubmitPinOpen}
          // onClose={onSubmitPinClose}
          currentStep={currentStep}
          setState={handleState}
          gotoNext={handleNext}
        />
      ),
      2: (
        <ForStep3
          state={state}
          // isOpen={isSubmitPinOpen}
          // onClose={onSubmitPinClose}
          setStep={setCurrentStep}
        />
      ),
    };

    return map[step];
  };

  const handleNext = () => {
    if (currentStep < maxStep - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onConfirm && onConfirm();
    }
    // onOpen();
  };

  useEffect(() => setCurrentStep(0), [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          {title}
        </ModalHeader>
        <ModalCloseButton
          top="10px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="24px 48px" bg="white">
          <AnimatePresence initial={false} exitBeforeEnter>
            <motion.div
              key={`motion-${currentStep}`}
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -50, opacity: 0 }}
              // transition={{  }}
            >
              {previewMap(currentStep)}
            </motion.div>
          </AnimatePresence>
        </ModalBody>

        <ModalFooter
          justifyContent="center"
          pb="30px"
          gridGap="14px"
          bg="white"
          flexDir="column"
        >
          {currentStep === 0 && (
            <Button
              minW="120px"
              w="100%"
              minH="50px"
              disabled={isLoading}
              onClick={handleNext}
              // bg="transparent"
              // border="2px solid transparent"
              // color="#03A438"
            >
              Scan code
            </Button>
          )}

          {currentStep === 1 && (
            <Button
              minW="120px"
              w="100%"
              minH="50px"
              disabled={isLoading}
              onClick={onClose}
              // bg="transparent"
              // border="2px solid transparent"
              // color="#03A438"
            >
              Close
            </Button>
          )}

          {currentStep !== 2 && (
            <Checkbox
              colorScheme="green"
              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
            >
              Do not show me this message again
            </Checkbox>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ClaimReward;
